// src/services/clientService.js
import api from './api';

const BASE = '/clients';

export default {
  list: (params) =>
    api
      .get(BASE, {
        params: {
          functionCode: 'CLIENT_VIEW',
          ...params,
        },
      })
      .then((r) => r.data),

  searchPaged: ({ q = '', page = 1, pageSize = 10 } = {}) =>
    api
      .get(`${BASE}/search`, {
        params: {
          functionCode: 'CLIENT_VIEW',
          q,
          page,
          pageSize,
        },
      })
      .then((r) => r.data),

  get: (id) =>
    api
      .get(`${BASE}/${id}`, {
        params: {
          functionCode: 'CLIENT_VIEW',
        },
      })
      .then((r) => r.data),

  create: (data) =>
    api
      .post(`${BASE}/`, {
        ...data,
        functionCode: 'CLIENT_CREATE',
      })
      .then((r) => r.data),

  update: (id, data) =>
    api
      .put(`${BASE}/${id}`, {
        ...data,
        functionCode: 'CLIENT_UPDATE',
      })
      .then((r) => r.data),

  activate: (id) =>
    api
      .patch(`${BASE}/${id}/activate`, {
        functionCode: 'CLIENT_ACTIVATE',
      })
      .then((r) => r.data),

  deactivate: (id) =>
    api
      .patch(`${BASE}/${id}/deactivate`, {
        functionCode: 'CLIENT_DEACTIVATE',
      })
      .then((r) => r.data),

  remove: (id) =>
    api
      .delete(`${BASE}/${id}`, {
        data: {
          functionCode: 'CLIENT_DELETE',
        },
      })
      .then((r) => r.data),
};